import {AnySchema} from 'yup';

/**
 * @description Utility type that take object type and return strongly typed Yup schema.
 * @example
 *
 * type YourType = {
 *   name: string;
 *   surname: string;
 *  }
 *
 * const YourFormSchema = object<TypedFormSchema<YourType>>({
 *   name: string().required(),
 *   surname: string().required(),
 * });
 *
 * */
export type TypedFormSchema<FormItems> = Partial<Record<keyof FormItems, AnySchema>>;
